"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkButton = exports.Link = void 0;
const React = __importStar(require("react"));
const styled_components_1 = require("styled-components");
const theme_provider_1 = require("@volkswagen-onehub/components-core/dist/theme-provider");
const utils_1 = require("./custom-text-fields/utils");
const linkBaseStyles = (0, styled_components_1.css) `
  position: relative;
  color: ${props => props.disabled
    ? props.theme.colors.content.disabled
    : props.theme.colors.content.active};
  text-decoration: none;

  ${props => props.disabled
    ? (0, styled_components_1.css) `
          pointer-events: none;
        `
    : (0, styled_components_1.css) `
          :hover,
          :focus {
            border-bottom-color: ${props.theme.colors.border.hover};
            color: ${props.theme.colors.content.hover};
          }
          :focus {
            ${(0, utils_1.createA11yOutlineStyles)(props)}
          }
        `}

  ${props => props.isInline &&
    (0, styled_components_1.css) `
      padding-bottom: 2px;
      border-bottom: 1px solid currentColor;
    `};
`;
const StyledLink = theme_provider_1.styled.a `
  ${linkBaseStyles}
`;
const StyledLinkButton = theme_provider_1.styled.button `
  cursor: pointer;
  background: none;
  border: none;
  padding: inherit;
  appearance: none;
  font-weight: inherit;
  ${linkBaseStyles}
`;
const Link = props => {
    const { children, href, onClick, onMouseOut, onMouseOver, rel, target, innerRef, isInline, title, property, typeOf, disabled, itemProp, className } = props;
    return (React.createElement(StyledLink, { ref: innerRef, isInline: isInline, href: (!disabled && href) || undefined, onClick: (!disabled && onClick) || undefined, onMouseOver: onMouseOver, onMouseOut: onMouseOut, target: target, rel: rel, title: title, property: property, typeOf: typeOf, disabled: disabled, itemProp: itemProp, className: className }, children));
};
exports.Link = Link;
const LinkButton = props => {
    const { children, onClick, innerRef, isInline, disabled, className } = props;
    return (React.createElement(StyledLinkButton, { ref: innerRef, isInline: isInline, onClick: (!disabled && onClick) || undefined, disabled: disabled, className: className }, children));
};
exports.LinkButton = LinkButton;
